import React from "react";
import { Button, Typography, Container } from "@mui/material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { useRouter } from 'next/router';
import CardExampleCardRotating from "components/RotatingCard/RotatingCardSmall.js";

import styles from "./SectionTEDAI2024.module.scss";

export default function SectionTEDAI2024() {
    const router = useRouter();

    const handleCardClick = (path) => {
        router.push(path);
    };

    const cards = [
        {
            title: "TEDAI 2024: Home Section",
            description: "Explore our comprehensive coverage of TEDAI 2024",
            image: "/img/tedai2024/gallery2/IMG_3.jpeg",
            path: "/tedai2024"
        },
        {
            title: "Day 1: Talks",
            description: "Discover the insights and innovations shared during the first day",
            image: "/img/tedai2024/home/ted-ai-header3.jpeg",
            path: "/tedai2024/tedai2024-day1-talks-summary"
        },
        {
            title: "Day 2: Panels",
            description: "Deep dive into the panel discussions and expert perspectives",
            image: "/img/tedai2024/gallery2/tedai2024_panels_header2.jpeg",
            path: "/tedai2024/tedai2024-day2-panels-summary"
        }
    ];

    return (
        <div className={styles.section}>
            <Container className={styles.container}>
                <Typography variant="h2" className={styles.title}>
                    Check out our Coverage of TEDAI 2024!!
                </Typography>
                <Typography className={styles.emphasis}>
                    Want to hear about the latest cutting edge developments in AI?
                </Typography>
                <Typography className={styles.subtitle}>
                    On October 22-23, 2024 <strong>we attended TEDAI 2024</strong>, the world's premier AI conference in San Francisco. A huge lineup of AI pioneers and practioners delivered a day of talks at the historic Herbst Theatre, followed by a day of interactive panels at Shack15 at the San Francisco Ferry Building.
                    <br /><br />
                    Speakers included: Carlo Rovelli, Max Jaderberg, Eugenia Kudya, Noam Brown, Jakob Uszkoreit, Ethan Mollick, Pedro Domingos and many more!
                    <br /><br />
                </Typography>

                {/* Flipping Cards Section */}
                
                    <h2 className={styles.sectionTitle}>Notable Speakers</h2>
                    <div className={styles.flipCardsContainer}>
                        <CardExampleCardRotating
                            frontTitle="Carlo Rovelli"
                            frontDescription={`• Theoretical Physicist
                                • World’s 50 Top Thinkers

                                Quote: "Time is a human construct"`}
                            backTitle="Key Topics"
                            backDescription={`• Time is a human construct
        • Time may not exist in nature
        • AI's time perception differs`}
                            frontImage="/img/tedai2024/headshots/carlos-rovelli.png"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                        <CardExampleCardRotating
                            frontTitle="Jessica Coon"
                            frontDescription={`• Professor of Linguistics @ McGill University
                                • Consultant for the 2016 film 'Arrival'
                                
                                Quote: "Humans reject fake languages"`}

                            backTitle="Key Topics"
                            backDescription={`• Languages have deep structural similarities.
        • Humans reject fake languages
        • LLMs have limited language diversity.`}
                            frontImage="/img/tedai2024/headshots/jessica-coon.png"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                        <CardExampleCardRotating
                            frontTitle="Jakob Uszkoreit"
                            frontDescription={`• CEO and Co-Founder, Inceptive Nucleics
                                • Co-Author of seminal paper 'Attention is all you need'
                                
                                Quote: "Human minds are limited, AI helps"`}
                            
                            backTitle="Key Topics"
                            backDescription={`• Human minds are Limited, AI helps
     • Science should embrace noisy data
     • AI should emphasise solutions over theory`}
                            frontImage="/img/tedai2024/headshots/jakob-uszkoreit1.png"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                        <CardExampleCardRotating
                            frontTitle="Surya Ganguly"
                            frontDescription={`• Professor of Applied Physics & Associate Director of HAI Institute at Stanford University
                                
                                Quote: "Human brains have predictive energy allocation"`}
                            
                            backTitle="Key Topics"
                            backDescription={`• Humans are efficient learning machines
      • AI should try match biology's efficiency
      • Human brains have predictive energy allocation.`}
                            frontImage="/img/tedai2024/headshots/surya-ganguly.png"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                        <CardExampleCardRotating
                            frontTitle="Max Jaderberg"
                            frontDescription=
                            {`• Chief AI Officer, Isomorphic Labs
                                • Co-Developer of AlphaStar, Grandmaster Starcraft II agent
                                
                                Quote: "We've saved 1 billion years of research"`}
                            
                            backTitle="Key Topics"
                            backDescription={`• AlphaFold is revolutionising drug design
      • Saved 1 billion years of research
      • Personalized medicine is coming, soon`}
                            frontImage="/img/tedai2024/headshots/max-jaderberg1.png"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                        <CardExampleCardRotating
                            frontTitle="Guillaume Verdon"
                            frontDescription=
                            {`• Founder & CEO, Extropic
                                • Creator of TensorFlow Quantum
                                
                                Quote: "Thermo chips are the new AI hardware"`}
                                
                            backTitle="Key Topics"
                            backDescription={`• AI should mimic brain's efficiency
      • Mesoscale is the key to efficient AI
      • Thermo chips are the new AI hardware.`}
                            frontImage="/img/tedai2024/headshots/guillaume-verdon.png"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                                                <CardExampleCardRotating
                            frontTitle="Ethan Mollick"
                            frontDescription=
                            {`• Co-Director, Generative AI Lab, Wharton School of the University of Pennsylvania
                                
                                Quote: "Use AI for growth, not just cost-cutting"`}
                                
                            backTitle="Key Topics"
                            backDescription={`• AI should mimic brain's efficiency
      • Mesoscale is the key to efficient AI
      • Thermo chips are the new AI hardware.`}
                            frontImage="/img/tedai2024/headshots/ethan-mollick.jpeg"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                                                <CardExampleCardRotating
                            frontTitle="Pedro Domingos"
                            frontDescription=
                            {`• Professor Emeritus of Computer Science and Engineering, University of Washington
                                
                                Quote: "In time the floor of senate will be like the stock exchange"`}
                            
                            backTitle="Key Topics"
                            backDescription={`• AI should mimic brain's efficiency
      • Mesoscale is the key to efficient AI
      • Thermo chips are the new AI hardware.`}
                            frontImage="/img/tedai2024/headshots/pedro-domingos.jpeg"
                            backImage="/img/tedai2024/gallery2/IMG_3.jpeg"
                        />
                    </div>
                
                <p><br /><br /></p>
                <h2 className={styles.sectionTitle}>Explore the conference</h2>

                <div className={styles.summaryCardContainer}>
                    
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            className={styles.clickableCard}
                            onClick={() => handleCardClick(card.path)}
                        >
                            <Card className={styles.card}>
                                <div className={styles.cardContent}>
                                    <div className={styles.imageContainer}>
                                        <img
                                            src={card.image}
                                            alt={card.title}
                                            className={styles.cardImage}
                                        />
                                    </div>
                                    <div className={styles.textContainer}>
                                        <h4 className={styles.cardTitle}>{card.title}</h4>
                                        <p className={styles.cardDescription}>{card.description}</p>
                                        <CardFooter>
                                            <span className={styles.readMore}>Read More</span>
                                        </CardFooter>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    ))}
                </div>

                <div className={styles.highlightBox}>
                    <Typography variant="h6" gutterBottom>
                        🎉 On October 22-23, 2024 we attended TEDAI 2024 in San Francisco
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        className={styles.ctaButton}
                        href="/tedai2024"
                    >
                        See what we learned at TEDAI 2024
                    </Button>
                </div>
            </Container>
        </div>
    );
}